import { useMutation } from '@tanstack/react-query';

import { objectionResponsesTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const editObjectionResponse = (
  payload: objectionResponsesTypes.EditObjectionResponsePayload
) => {
  const { id, ...data } = payload;

  return axios.patch(`/ai/objection-responses/${id}`, data);
};

type QueryFnType = typeof editObjectionResponse;

type UseEditObjectionResponseOptions = {
  config?: MutationConfig<QueryFnType>;
};

export const useEditObjectionResponse = ({ config }: UseEditObjectionResponseOptions = {}) => {
  const { onSuccess, ...restConfig } = config || {};

  return useMutation({
    ...restConfig,
    mutationFn: editObjectionResponse,
    onSuccess: (_data, variables, context) => {
      queryClient.invalidateQueries(['objection-responses', variables.aiId]);
      onSuccess?.(_data, variables, context);
    },
  });
};
